import { Capacitor } from "@capacitor/core";
/**
 * Workaround visual iOS: WKWebView puede dejar visualViewport.scale ≠ 1 tras
 * focus-zoom (inputs < 16px). Best-effort: nunca lanza; no mueve scroll;
 * maximum-scale=1 es temporal. El viewport permanente no se altera.
 */
let restoreTimer = null;
let viewportContentToRestore = null;
const restoreViewportMeta = () => {
    const original = viewportContentToRestore;
    if (!original || typeof document === "undefined") {
        restoreTimer = null;
        viewportContentToRestore = null;
        return;
    }
    const meta = document.querySelector('meta[name="viewport"]');
    if (meta instanceof HTMLMetaElement) {
        meta.setAttribute("content", original);
    }
    restoreTimer = null;
    viewportContentToRestore = null;
};
export const resetIosVisualViewportScale = (options) => {
    try {
        if (typeof document === "undefined" || typeof window === "undefined") {
            return;
        }
        if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "ios") {
            return;
        }
        if (options?.onlyIfZoomed) {
            const scale = window.visualViewport?.scale;
            if (typeof scale !== "number" || !(scale > 1.01)) {
                return;
            }
        }
        if (options?.blur !== false) {
            const active = document.activeElement;
            if (active instanceof HTMLElement) {
                active.blur();
            }
        }
        const meta = document.querySelector('meta[name="viewport"]');
        if (!(meta instanceof HTMLMetaElement)) {
            return;
        }
        const current = meta.getAttribute("content") || "";
        if (!current) {
            return;
        }
        if (!viewportContentToRestore) {
            if (/maximum-scale/i.test(current)) {
                return;
            }
            viewportContentToRestore = current;
        }
        meta.setAttribute("content", `${viewportContentToRestore}, maximum-scale=1.0`);
        if (restoreTimer !== null) {
            clearTimeout(restoreTimer);
        }
        restoreTimer = setTimeout(() => {
            try {
                restoreViewportMeta();
            }
            catch {
                viewportContentToRestore = null;
                restoreTimer = null;
            }
        }, 100);
    }
    catch {
        // Best-effort: login/resume no dependen de este workaround.
    }
};
